<template>
<div class="card shadow mb-4">
    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
        <h6 v-if="current_page=='Substations'" class="m-0 font-weight-bold">{{ $t('State_of_charge') }}</h6>
        <h6 v-else class="m-0 font-weight-bold">{{ $t('Battery_occupation') }}</h6>
        <i class="fas fa-info-circle" data-toggle="tooltip" data-placement="top" :title="$t('home_tooltip_battery_occupation')"></i>
    </div>
    <div class="card-body text-center">
        <LoadingSpinner v-if="loading"></LoadingSpinner>
        <div v-show="!loading" id="canvas-batteryoccupation"></div>
    </div>
</div>
</template>

<script>
import LoadingSpinner from './LoadingSpinner.vue'

export default {
  name: 'BatteryOccupation',
  components: {
    LoadingSpinner
  },
  data() {
    return {
        chart: null,
        clock: null,
        sec: 0,
        x_color: "rgba(0,204,102,0.3)",
        y_color: "rgba(278,102,255,0.3)",
        series: {
            cheapest_hours: {
                name: this.$i18n.t('Cheapest_hours'),
                color: "rgba(0,204,102, 0.3)",
                index: 0,
                type: 'area',
            }, 
            battery_limits: {
                name: this.$i18n.t('Battery_limits'),
                color: "rgba(278,102,255, 0.3)" ,
                index: 1,
                type: 'area',
            }     
        }
    }
  }, 
  mounted: function(){
    const self = this
    const x_color = "rgba(0,204,102, 0.3)"
    const y_color = "rgba(278,102,255, 0.3)" 

    const chart_options = {
        title: {
          text: null
        },

        chart: {
            backgroundColor: '#fff'
        },

        credits: { enabled: false },

        xAxis: {
            plotBands: this.current_page == 'Substations' ? null : self.plotBandsX,
            type: 'datetime',
            dateTimeLabelFormats: {
                day: '%a, %e %b'
            },
        },
    
        yAxis: {
            plotBands: this.current_page == 'Substations' ? null : self.plotBandsY,
            min: 0,
            max: 100,
            tickInterval: 20,
            title: null
        },

        tooltip: {
            shared: true,
            valueDecimals: 0,
            xDateFormat: '%A, %d %b, %H:%M',
        },
    
        plotOptions: {
            series: {
                minPointLength: 1,
                shadow: false,
                marker: {
                    enabled: false
                }
            },
            area: {
                events: {
                    legendItemClick: function (e) {
                        if (this.current_page != 'Substations') {
                            if (this.index == 0) {
                                self.toggleBandsX();
                            }
                            else if (this.index == 1) {
                                self.toggleBandsY();
                            }
                        }
                    }
                }
            },
        },

        symbols: ['circle', 'circle'],
        series: [
            /* {
                name: this.$i18n.t('Cheapest_hours'),
                color: self.x_color,
                index: 0,
                type: 'area',
            }, {
                name: this.$i18n.t('Battery_limits'),
                color: self.y_color,
                index: 1,
                type: 'area',
            }        */
        ]
    }
    //if (this.current_page == 'Substations') chart_options.series = []
    this.chart = Highcharts.chart('canvas-batteryoccupation', chart_options)
  },
  methods: {
    toggleBandsX: function() {
        var i = this.chart.xAxis[0].plotLinesAndBands.length;
        if (i > 0) {
            while (i--) {
                this.chart.xAxis[0].plotLinesAndBands[i].destroy();
            }
        } else {
            this.chart.xAxis[0].update({
                plotBands: this.plotBandsX,
            });
        }
    },
    toggleBandsY: function() {
        var i = this.chart.yAxis[0].plotLinesAndBands.length;
        if (i > 0) {
            while (i--) {
                this.chart.yAxis[0].plotLinesAndBands[i].destroy();
            }
        } else {
            this.chart.yAxis[0].update({
                plotBands: this.plotBandsY
            });
        }
    },
    update_plotBandsX: function(){
        this.chart.xAxis[0].update({
            plotBands: this.plotBandsX,
        });
    },
    add_battery_series: async function(){
        if (this.data == {} || !this.data.length) {
            //while (this.chart.series.length > 2) this.chart.series[this.chart.series.length-1].remove()
            while (this.chart.series.length) this.chart.series[this.chart.series.length-1].remove()
            return
        }
        
        //while (this.chart.series.length > 2) this.chart.series[this.chart.series.length-1].remove()
        while (this.chart.series.length) this.chart.series[this.chart.series.length-1].remove()

        if (this.current_page != 'Substations') {
            this.chart.addSeries(this.series.cheapest_hours)
            this.chart.addSeries(this.series.battery_limits)
        }

        //if (this.chart.series.length <= 2) {
            this.data.forEach(b => {
                this.chart.addSeries({ 
                    name: this.current_page == 'Substations' ? `${this.$i18n.t('State_of_charge')} ${b.name}` : `${this.$i18n.t('Battery_occupation')} ${b.name}`, 
                    color: "#1cc88a", 
                    type: "spline",
                    tooltip: {
                        valueSuffix: ' %',
                        valueDecimals: 0
                    },
                    data: b.summaryChart.length ? b.summaryChart.map(r => [moment.tz(r.datetime, this.timezone).valueOf(), r.battery_capacity]) : []
                })
            })
        /* } else {
            this.data.map((b, i) => {
                this.chart.series[i+2].setData(b.summaryChart.map(r => [moment.tz(r.datetime, this.timezone).valueOf(), r.battery_capacity]))
            })
        } */

        if (this.current_page != 'Substations') {
            if (this.user_contract.tariff == "simple") {
                this.chart.series[0].update({ visible: false })
                return
            }
            this.chart.series[0].update({ visible: true })
            this.chart.xAxis[0].update({
                plotBands: this.plotBandsX,
            });
        }
    },
  },
  computed: {
    data: function() {
        return this.$store.getters.data.length ? this.$store.getters.data[0].batteries : {}
    },
    current_lang: function(){
      return this.$i18n.locale
    },
    current_page: function(){
      return this.$route.name
    },
    loading: function() {
        //if (this.current_page == "Substations") return false
        return this.$store.getters.data_loading
    },
    user_contract: function() {
        return this.$store.getters.user_contract
    },
    plotBandsX: function() {
        //23h00 - 08h59 - Empty hours
        let bands = []
        let band = {}
        let i = 0
        if (this.data == {} || !this.data.length) return bands
        for (let s of this.data[0].summaryChart) {
            const date = new Date(s.datetime)
            if (date.getHours() >= 23 || date.getHours() < 9) {
                if (!band.hasOwnProperty('from')) {
                    band.color = this.x_color
                    band.from = new Date(s.datetime) // i
                    band.to = null
                }
            }
            else if (date.getHours() >= 9 && date.getHours() < 23) {
                if (band.hasOwnProperty('to') && band.to == null) {
                    band.to = new Date(s.datetime) // i-1
                    bands.push(band)
                    band = {}
                }
            }
            i++
        }

        return bands
    },
    plotBandsY: function() {
        return [{ 
            color: this.y_color,
            from: 0,
            to: 20
        }, {
            color: this.y_color,
            from: 90,
            to: 100
        }]
    },
  },
  watch: {
    data: function() {
        this.add_battery_series()
    },
    current_lang: function(){
        if (this.current_page != 'Substations') {
            this.chart.series[0].update({name: this.$i18n.t('Cheapest_hours')}, true);
            this.chart.series[1].update({name: this.$i18n.t('Battery_limits')}, true);
        }
        this.add_battery_series();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>